var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    id: "discord",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#7289DA",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.0367 15.7798C33.8349 14.0183 31.1927 13.1376 28.4037 12.9908L27.9633 13.4312C30.4587 14.0183 32.6606 15.1926 34.7156 16.8073C32.2202 15.4862 29.4312 14.6055 26.4954 14.3119C25.6147 14.1651 24.8807 14.1651 24 14.1651C23.1193 14.1651 22.3853 14.1651 21.5046 14.3119C18.5688 14.6055 15.7798 15.4862 13.2844 16.8073C15.3394 15.1926 17.5413 14.0183 20.0367 13.4312L19.5963 12.9908C16.8073 13.1376 14.1651 14.0183 11.9633 15.7798C9.46789 20.4771 8.14679 25.7615 8 31.1926C10.2018 33.5413 13.2844 35.0092 16.5138 35.0092C16.5138 35.0092 17.5413 33.8349 18.2752 32.8073C16.367 32.367 14.6055 31.3394 13.4312 29.7248C14.4587 30.3119 15.4862 30.8991 16.5138 31.3394C17.8349 31.9266 19.156 32.2202 20.4771 32.5138C21.6514 32.6605 22.8257 32.8073 24 32.8073C25.1743 32.8073 26.3486 32.6605 27.5229 32.5138C28.844 32.2202 30.1651 31.9266 31.4862 31.3394C32.5138 30.8991 33.5413 30.3119 34.5688 29.7248C33.3945 31.3394 31.633 32.367 29.7248 32.8073C30.4587 33.8349 31.4862 35.0092 31.4862 35.0092C34.7156 35.0092 37.7982 33.5413 40 31.1926C39.8532 25.7615 38.5321 20.4771 36.0367 15.7798ZM19.156 28.5504C17.6881 28.5504 16.367 27.2293 16.367 25.6147C16.367 24 17.6881 22.6789 19.156 22.6789C20.6239 22.6789 21.945 24 21.945 25.6147C21.945 27.2293 20.6239 28.5504 19.156 28.5504ZM28.844 28.5504C27.3761 28.5504 26.055 27.2293 26.055 25.6147C26.055 24 27.3761 22.6789 28.844 22.6789C30.3119 22.6789 31.633 24 31.633 25.6147C31.633 27.2293 30.3119 28.5504 28.844 28.5504Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.a60a359c59bfe550ffee8d979c0faccd.svg";
export { ForwardRef as ReactComponent };